// extracted by mini-css-extract-plugin
export default {"loading":"Loader_loading__Uz3+-","search":"Loader_search__B7o3u"};